// removed by extract-text-webpack-plugin
module.exports = {"block":"_6Pe2m-WvL4vDtSDlAjL0X","background":"_2Kdq7QWNYL-a4Z7_X7tY-a","heading":"_2GQ7j9tlSzppZaIqc71c92","wrapper":"exTA1A0eYS_ETwiqXLVno","group":"_3ajQkZtRSDBHnVbYCG_aZ-","links":"_1S_5yRv_IeTnk1C-DHZjJ8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkGroupListBlock/LinkGroupListBlock.module.scss
// module id = 782
// module chunks = 0